.ux-w-service-calls-item {
    display: inline-block;
    min-width: 280px;
    max-width: 280px;
    padding: 20px 30px;
    position: relative;

    .ux-text-tiny {
        text-transform: uppercase;
    }

    &__header {
        padding-bottom: 10px;
        margin-bottom: 15px;
        border-bottom: 1px solid rgba($color-black, 0.2);
    }

    &__headline {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .ux-text-status {
        position: relative;
        margin-bottom: 20px;
    }

    &__label {
        margin-top: 10px;
    }

    &__bottom {
        margin-right: 50px;
    }

    &__button {
        position: absolute;
        bottom: 30px;
        right: 30px;
    }
}
